import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { AxiosError } from 'axios';

import { API_V2, ApiV2Response } from './types';

export const useUser = (enabled: boolean | undefined) => {
  return useQuery<UserResponse, AxiosError>({
    queryKey: ['user'],
    queryFn: () => getUser(),
    enabled,
  });
};

export const getUser = async (includeRelated: string[] = []): Promise<UserResponse> => {
  const response = await axios.get<ApiV2Response<UserResponse>>(`${API_V2}/whoami/`, {
    params: {
      include_related: JSON.stringify(includeRelated),
    },
  });
  return response?.data?.data;
};

export interface UserResponse {
  user: {
    id: number;
    permissions: {
      account_id: number;
      id: number;
      permission_statements: {
        permission: string;
        target_resource: number | null;
        all_resources: boolean;
      }[];
    }[];
  };
}
